export const Account = Object.freeze({
  loggedIn: "LoggedIn",
  loggedOut: "LoggedOut",
});

export const Constants = Object.freeze({
  guid: "00000000-0000-0000-0000-000000000000",
});

export const Loader = Object.freeze({
  bottom: "bottom",
  menu: "menu",
  toolbar: "toolbar,"
});

export const Status = Object.freeze({
  error: "error",
  success: "success",
  warning: "warning",
});

export const Roles = Object.freeze({
  administrator: "Administrator",
  blogger: "Blogger",
  foreman: "Foreman",
  manager: "Office Manager",
  user: "User",
});

export const Theme = Object.freeze({
  dark: "Dark Theme",
  light: "Light Theme"
});




